module.exports = __webpack_public_path__ + "static/media/redpacket.02966578.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/redpacket.png
// module id = 1853
// module chunks = 6